import React from "react";
import { Amplify } from "aws-amplify";
import { Authenticator } from "@aws-amplify/ui-react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import routes from "./Config/routes";
import { AuthProvider } from "./Context";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PrimeReactProvider } from "primereact/api";
import "./globalStyles"; // Import the central CSS file
import awsExports from "./aws-exports";
import FeatureEnabled from "./Components/FeatureEnabled";
import RoleBasedAccess from "./Components/RoleBasedAccess";
import config from "./config";
import Home from "./Components/Home/Home";
Amplify.configure(awsExports);

const queryClient = new QueryClient();

function App() {
  return (
    <Authenticator hideSignUp>
      <QueryClientProvider client={queryClient}>
        {/* <ThemeProvider theme={theme}> */}
        <AuthProvider>
          <PrimeReactProvider value={{ ripple: true }}>
            <Router>
              <Routes>
                <Route
                  path="/"
                  element={
                    <RoleBasedAccess allowedRoles={[]}>
                      <Home />
                    </RoleBasedAccess>
                  }
                />
                {routes.map((route, index) => {
                  const { path, component: Component, feature, children } = route;
                  return (
                    <Route
                      key={index}
                      path={path}
                      element={
                        <FeatureEnabled feature={feature}>
                          <RoleBasedAccess
                            allowedRoles={config.FEATURE_FLAGS[feature]?.roles || []}
                          >
                            <Component />
                          </RoleBasedAccess>
                        </FeatureEnabled>
                      }
                    >
                      {children?.map((child, childIndex) => (
                        <Route
                          key={`${index}-${childIndex}`}
                          path={child.path}
                          element={<child.component />}
                        />
                      ))}
                    </Route>
                  );
                })}
              </Routes>
            </Router>
          </PrimeReactProvider>
        </AuthProvider>
      </QueryClientProvider>
    </Authenticator>
  );
}

export default App;
